/**
 * Empty/not-found message block.
 *
 * Moved from oem's `components/_notFoundMessage` so @shared/ui's PartDocuments
 * is self-contained. The two icons it renders came from oem's icon module and
 * are inlined here; oem keeps its copies.
 */
import React from "react";

import { NoTicketsLargeIcon } from "@shared/ui/NoTicketsLargeIcon";
import { useIntl } from "react-intl";

const NotFoundMessage = ({ className, text, variant = "" }) => {
  const classes = [
    `c-notFoundMessage ${className}`,
    variant ? `c-notFoundMessage--${variant}` : "",
  ].join(" ");

  return (
    <div className={classes}>
      <p className="c-notFoundMessageText text-sm">{text}</p>
    </div>
  );
};

export const NotFoundComponent = ({
  title = null,
  icon = null,
  showIcon = true,
  showTitle = true,
  className = "no-tickets-wrapper full-page",
}) => {
  const { messages: msg } = useIntl();

  return (
    <div className={className}>
      {showIcon && (
        <span className="no-tickets-icon">
          {icon || <NoTicketsLargeIcon />}
        </span>
      )}

      {showTitle && (
        <p className="no-tickets-title">{title || `${msg.common?.notFound}`}</p>
      )}
    </div>
  );
};

export default NotFoundMessage;

// Lives in its own module so it can be imported without this one.
export { NoTicketsLargeIcon };

export const DeleteTrashImage = () => (
  <svg
    width="130"
    height="130"
    viewBox="0 0 130 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.2571 43.5971L81.2275 20.9417L64.5577 9.91301L46.9833 13.0247C46.6113 13.0904 46.2559 13.2288 45.9375 13.432C45.6191 13.6352 45.3438 13.8991 45.1275 14.2088C44.9111 14.5184 44.758 14.8677 44.6767 15.2366C44.5955 15.6055 44.5877 15.9868 44.654 16.3587L49.4149 43.2392L47.8879 43.5193L43.1137 16.6387C43.0122 16.0656 43.0247 15.4781 43.1503 14.9098C43.2759 14.3415 43.5122 13.8035 43.8458 13.3266C44.1793 12.8496 44.6035 12.443 45.0942 12.13C45.5848 11.8169 46.1323 11.6036 46.7055 11.5022L64.8911 8.27271L82.6455 20.0216L86.7841 43.3237L85.2571 43.5971Z"
      fill="#172B4D"
    />
    <rect
      x="33.0909"
      y="43.7273"
      width="67.9545"
      height="9.45454"
      fill="#CDD1FE"
    />
    <rect
      x="30.1364"
      y="60.8636"
      width="11.8182"
      height="5.31818"
      fill="#CDD1FE"
    />
    <rect
      x="91.5909"
      y="60.8636"
      width="11.8182"
      height="5.31818"
      fill="#CDD1FE"
    />
    <path
      d="M81.3831 20.7906C76.6777 21.6796 72.9882 22.1464 71.0278 22.2464C70.361 22.2797 69.2008 22.302 68.2406 21.6307C67.7479 21.287 67.3453 20.8296 67.0671 20.2971C66.9287 20.0309 66.8235 19.7488 66.7537 19.457C66.7292 19.3614 66.7159 19.2858 66.7092 19.2347V19.2125C66.6959 19.1391 66.0157 16.3631 64.3688 9.65515"
      fill="#0517F8"
    />
    <path
      d="M70.5588 23.0377C69.5802 23.0782 68.6134 22.8117 67.7939 22.2753C67.2002 21.8588 66.7147 21.3063 66.378 20.6639C66.2099 20.3415 66.0823 19.9996 65.998 19.6459C65.9757 19.5548 65.958 19.477 65.9491 19.4237V19.3792C65.9068 19.1947 65.4623 17.3655 63.6175 9.85299L65.1289 9.48181C67.0648 17.3677 67.3982 18.7435 67.4627 19.0169L67.4805 19.1014C67.4805 19.1414 67.5005 19.2036 67.5183 19.2792C67.6868 19.9765 68.1051 20.5877 68.694 20.9973C69.3919 21.4863 70.2499 21.5129 70.9967 21.4729C73.2193 21.3596 77.0578 20.8195 81.2475 20.0305L81.5342 21.5596C77.2801 22.362 73.3705 22.911 71.0878 23.0288C70.9056 23.031 70.7366 23.0377 70.5588 23.0377ZM65.958 19.4437C65.9573 19.4526 65.9573 19.4615 65.958 19.4703V19.4437Z"
      fill="#172B4D"
    />
    <path
      d="M99.2575 54.3213H34.4654C33.713 54.3201 32.9917 54.0207 32.4597 53.4886C31.9277 52.9566 31.6283 52.2354 31.6271 51.483V45.2596C31.6283 44.5072 31.9277 43.7859 32.4597 43.2539C32.9917 42.7219 33.713 42.4224 34.4654 42.4213H99.2575C100.01 42.4224 100.731 42.7219 101.263 43.2539C101.795 43.7859 102.095 44.5072 102.096 45.2596V51.483C102.095 52.2354 101.795 52.9566 101.263 53.4886C100.731 54.0207 100.01 54.3201 99.2575 54.3213ZM34.4654 43.986C34.1255 43.9866 33.7996 44.1219 33.5592 44.3623C33.3188 44.6027 33.1835 44.9285 33.1829 45.2685V51.4918C33.1835 51.8318 33.3188 52.1577 33.5592 52.398C33.7996 52.6384 34.1255 52.7737 34.4654 52.7743H99.2575C99.5975 52.7737 99.9233 52.6384 100.164 52.398C100.404 52.1577 100.539 51.8318 100.54 51.4918V45.2685C100.539 44.9285 100.404 44.6027 100.164 44.3623C99.9233 44.1219 99.5975 43.9866 99.2575 43.986H34.4654Z"
      fill="#172B4D"
    />
    <path
      d="M94.55 121.727H38.9084L36.608 66.3325L38.1616 66.268L40.4021 120.171H93.063L95.459 66.1102L97.0126 66.1791L94.55 121.727Z"
      fill="#172B4D"
    />
    <path
      d="M36.3813 60.887L36.0435 52.7655H97.6061L97.2638 60.5069L95.7102 60.438L95.9813 54.3213H37.666L37.9349 60.8226L36.3813 60.887Z"
      fill="#172B4D"
    />
    <path
      d="M66.8626 114.117C65.7647 114.116 64.7122 113.679 63.9359 112.903C63.1596 112.127 62.723 111.074 62.7218 109.976V65.8257C62.7469 64.7444 63.194 63.7159 63.9676 62.96C64.7412 62.2041 65.7799 61.7809 66.8615 61.7809C67.943 61.7809 68.9817 62.2041 69.7553 62.96C70.5289 63.7159 70.9761 64.7444 71.0011 65.8257V109.976C70.9999 111.074 70.5636 112.126 69.7878 112.902C69.012 113.678 67.96 114.115 66.8626 114.117ZM66.8626 63.243C66.1776 63.2436 65.5208 63.5158 65.0362 64C64.5516 64.4842 64.2788 65.1407 64.2776 65.8257V109.976C64.2675 110.322 64.3268 110.666 64.4521 110.988C64.5774 111.311 64.7661 111.605 65.007 111.853C65.248 112.101 65.5362 112.298 65.8548 112.433C66.1733 112.568 66.5156 112.637 66.8615 112.637C67.2073 112.637 67.5496 112.568 67.8681 112.433C68.1867 112.298 68.475 112.101 68.7159 111.853C68.9568 111.605 69.1455 111.311 69.2708 110.988C69.3961 110.666 69.4554 110.322 69.4453 109.976V65.8257C69.4441 65.1411 69.1716 64.4849 68.6875 64.0008C68.2034 63.5167 67.5472 63.2442 66.8626 63.243Z"
      fill="#172B4D"
    />
    <path
      d="M81.8942 114.117C80.7968 114.115 79.7448 113.678 78.969 112.902C78.1932 112.126 77.7569 111.074 77.7557 109.976V65.8257C77.7557 64.7281 78.1917 63.6754 78.9679 62.8993C79.744 62.1232 80.7966 61.6871 81.8942 61.6871C82.9919 61.6871 84.0445 62.1232 84.8206 62.8993C85.5968 63.6754 86.0328 64.7281 86.0328 65.8257V109.976C86.0316 111.074 85.5953 112.126 84.8195 112.902C84.0437 113.678 82.9917 114.115 81.8942 114.117ZM81.8942 63.243C81.2096 63.2442 80.5534 63.5166 80.0693 64.0007C79.5852 64.4848 79.3127 65.1411 79.3116 65.8257V109.976C79.3116 110.661 79.5837 111.318 80.068 111.802C80.5524 112.287 81.2093 112.559 81.8942 112.559C82.5792 112.559 83.2361 112.287 83.7205 111.802C84.2048 111.318 84.4769 110.661 84.4769 109.976V65.8257C84.4758 65.1411 84.2033 64.4848 83.7192 64.0007C83.2351 63.5166 82.5789 63.2442 81.8942 63.243Z"
      fill="#172B4D"
    />
    <path
      d="M51.3975 114.117C50.3 114.115 49.248 113.678 48.4722 112.902C47.6964 112.126 47.2601 111.074 47.2589 109.976V65.8257C47.2589 64.7281 47.6949 63.6754 48.4711 62.8993C49.2472 62.1232 50.2999 61.6871 51.3975 61.6871C52.4951 61.6871 53.5477 62.1232 54.3239 62.8993C55.1 63.6754 55.536 64.7281 55.536 65.8257V109.976C55.5348 111.074 55.0985 112.126 54.3227 112.902C53.5469 113.678 52.4949 114.115 51.3975 114.117ZM51.3975 63.243C50.7128 63.2442 50.0566 63.5166 49.5725 64.0007C49.0884 64.4848 48.8159 65.1411 48.8148 65.8257V109.976C48.8148 110.661 49.0869 111.318 49.5712 111.802C50.0556 112.287 50.7125 112.559 51.3975 112.559C52.0824 112.559 52.7394 112.287 53.2237 111.802C53.7081 111.318 53.9802 110.661 53.9802 109.976V65.8257C53.979 65.1411 53.7065 64.4848 53.2224 64.0007C52.7383 63.5166 52.0821 63.2442 51.3975 63.243Z"
      fill="#172B4D"
    />
    <path
      d="M43.087 67.2238H32.3695C31.8836 67.2358 31.4003 67.1505 30.948 66.9728C30.4957 66.7952 30.0834 66.5289 29.7356 66.1895C29.3877 65.8502 29.1113 65.4446 28.9226 64.9968C28.7338 64.549 28.6366 64.0679 28.6366 63.582C28.6366 63.096 28.7338 62.615 28.9226 62.1672C29.1113 61.7193 29.3877 61.3138 29.7356 60.9744C30.0834 60.6351 30.4957 60.3688 30.948 60.1911C31.4003 60.0135 31.8836 59.9282 32.3695 59.9402H43.087V67.2238ZM32.3695 61.496C32.0898 61.4869 31.8112 61.5341 31.5501 61.6348C31.2891 61.7355 31.0509 61.8877 30.8499 62.0823C30.6488 62.2769 30.4889 62.51 30.3798 62.7676C30.2706 63.0252 30.2143 63.3022 30.2143 63.582C30.2143 63.8618 30.2706 64.1387 30.3798 64.3964C30.4889 64.654 30.6488 64.887 30.8499 65.0816C31.0509 65.2762 31.2891 65.4284 31.5501 65.5291C31.8112 65.6299 32.0898 65.6771 32.3695 65.6679H41.5312V61.496H32.3695Z"
      fill="#172B4D"
    />
    <path
      d="M101.411 67.2238H90.6915V59.9402H101.411C102.362 59.9637 103.265 60.3577 103.929 61.0381C104.593 61.7185 104.964 62.6314 104.964 63.582C104.964 64.5326 104.593 65.4455 103.929 66.1259C103.265 66.8063 102.362 67.2003 101.411 67.2238ZM92.2473 65.6679H101.411C101.953 65.6502 102.466 65.4227 102.843 65.0335C103.22 64.6442 103.43 64.1237 103.43 63.582C103.43 63.0402 103.22 62.5197 102.843 62.1305C102.466 61.7412 101.953 61.5137 101.411 61.496H92.2473V65.6679Z"
      fill="#172B4D"
    />
    <path
      d="M101.82 37.5004C101.751 37.5009 101.682 37.4904 101.616 37.4693C101.448 37.4152 101.308 37.2966 101.227 37.1395C101.146 36.9824 101.131 36.7996 101.185 36.6313L102.925 31.2059C102.979 31.0373 103.098 30.897 103.255 30.8159C103.412 30.7349 103.595 30.7196 103.764 30.7736C103.933 30.8275 104.073 30.9462 104.154 31.1036C104.235 31.2609 104.25 31.444 104.196 31.6126L102.454 37.0381C102.41 37.1722 102.326 37.2891 102.212 37.3722C102.098 37.4552 101.961 37.5001 101.82 37.5004Z"
      fill="#172B4D"
    />
    <path
      d="M107.372 41.6967C107.229 41.6968 107.09 41.6507 106.975 41.5653C106.86 41.4799 106.775 41.3598 106.734 41.2226C106.692 41.0854 106.696 40.9386 106.745 40.8038C106.793 40.669 106.884 40.5535 107.003 40.4743L111.747 37.3181C111.819 37.2697 111.901 37.2361 111.987 37.2192C112.073 37.2024 112.162 37.2026 112.247 37.22C112.333 37.2373 112.415 37.2714 112.488 37.3203C112.56 37.3691 112.623 37.4319 112.671 37.5048C112.72 37.5778 112.753 37.6596 112.77 37.7456C112.787 37.8315 112.787 37.9199 112.769 38.0058C112.752 38.0917 112.718 38.1733 112.669 38.246C112.62 38.3186 112.557 38.381 112.484 38.4294L107.741 41.5856C107.632 41.6581 107.504 41.6968 107.372 41.6967Z"
      fill="#172B4D"
    />
    <path
      d="M106.054 38.0183C105.93 38.0181 105.808 37.9832 105.703 37.9176C105.598 37.8519 105.513 37.7581 105.458 37.6467C105.403 37.5354 105.38 37.4108 105.392 37.2872C105.404 37.1636 105.45 37.0457 105.525 36.947L108.977 32.415C109.084 32.2742 109.243 32.1817 109.419 32.1579C109.594 32.1341 109.772 32.1811 109.913 32.2883C110.054 32.3956 110.146 32.5545 110.17 32.73C110.194 32.9055 110.147 33.0832 110.04 33.2241L106.586 37.756C106.523 37.8377 106.443 37.9039 106.351 37.9494C106.259 37.9949 106.157 38.0185 106.054 38.0183Z"
      fill="#172B4D"
    />
    <path
      d="M47.8038 100.758C53.3407 95.2208 53.3407 86.2436 47.8038 80.7067C42.2669 75.1697 33.2897 75.1697 27.7528 80.7067C22.2159 86.2436 22.2159 95.2208 27.7528 100.758C33.2897 106.295 42.2669 106.295 47.8038 100.758Z"
      fill="#FDE5F0"
    />
    <path
      d="M37.7772 105.689C34.8193 105.688 31.9279 104.811 29.4686 103.167C27.0094 101.523 25.0928 99.1873 23.9611 96.4544C22.8295 93.7215 22.5336 90.7144 23.1109 87.8133C23.6883 84.9123 25.1129 82.2476 27.2046 80.1561C29.2964 78.0647 31.9613 76.6405 34.8624 76.0636C37.7636 75.4867 40.7707 75.783 43.5034 76.9151C46.2362 78.0471 48.5718 79.9641 50.2151 82.4236C51.8585 84.883 52.7356 87.7746 52.7356 90.7325C52.7314 94.6982 51.1541 98.5003 48.3497 101.304C45.5453 104.108 41.7429 105.685 37.7772 105.689ZM37.7772 77.3322C35.127 77.3327 32.5364 78.1189 30.333 79.5917C28.1296 81.0644 26.4124 83.1574 25.3985 85.606C24.3846 88.0546 24.1196 90.7489 24.6369 93.3481C25.1542 95.9474 26.4306 98.3349 28.3048 100.209C30.1789 102.083 32.5666 103.359 35.166 103.875C37.7653 104.392 40.4596 104.127 42.908 103.113C45.3565 102.098 47.4492 100.381 48.9215 98.1771C50.3939 95.9734 51.1797 93.3827 51.1797 90.7325C51.1756 87.1794 49.7622 83.773 47.2495 81.2608C44.7369 78.7486 41.3303 77.3357 37.7772 77.3322Z"
      fill="#172B4D"
    />
    <path
      d="M44.7047 95.3349L33.8012 85.0886C33.2711 84.5905 32.4375 84.6164 31.9394 85.1465C31.4412 85.6766 31.4671 86.5101 31.9972 87.0083L42.9008 97.2546C43.4309 97.7527 44.2644 97.7268 44.7626 97.1967C45.2607 96.6666 45.2348 95.833 44.7047 95.3349Z"
      fill="#EE0064"
    />
    <path
      d="M42.8261 84.5597L32.2263 95.0711C31.7031 95.59 31.6995 96.4348 32.2184 96.9581C32.7373 97.4813 33.5821 97.4849 34.1054 96.966L44.7052 86.4546C45.2285 85.9357 45.232 85.0909 44.7131 84.5676C44.1942 84.0443 43.3494 84.0408 42.8261 84.5597Z"
      fill="#EE0064"
    />
  </svg>
);
